/**
 * Ссылки из поля ввода. Список обычно копируют из чата вместе с подписями:
 *
 *   Kazpress
 *   https://www.instagram.com/p/DdRFbddDD6z/?stkn=dHprbXJuODcyaGVm
 *
 * Поэтому берутся только слова, похожие на ссылку, — где бы они ни стояли, —
 * а подписи пропускаются молча. Ссылка не на пост (сторис, другой сайт)
 * остаётся в списке, чтобы пользователь увидел её в ошибках.
 */

const LINK_START = /^(?:https?:\/\/|www\.|(?:[\w-]+\.)*instagram\.com\/|instagr\.am\/)/i;
// Знаки препинания, прилипшие к ссылке в тексте: «…/?stkn=abc;», «(ссылка)».
// «=» не трогаем — им заканчивается base64 в stkn.
const TRAILING_PUNCTUATION = /[.,;:!?)\]»"']+$/;
const LEADING_PUNCTUATION = /^[([«"']+/;

export function extractLinks(text: string): string[] {
  return text
    .split(/\s+/)
    .map((word) => word.replace(LEADING_PUNCTUATION, '').replace(TRAILING_PUNCTUATION, ''))
    .filter((word) => LINK_START.test(word));
}
